export default __webpack_public_path__ + "static/discover_section-a18673edec7c689e7e682e4e433daa0e.webp";